import "./ForgotPassword.css";

import * as animationData from "../../../assets/animations/login-anim-temp.json";

import {
  setForgotPasswordVisible,
  setLoginVisible,
} from "../../../store/modals/modalActions";
import { useEffect, useState } from "react";

import CustomInput from "../../CustomInput/CustomInput";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Lottie from "react-lottie";
import Modal from "react-modal";
import ReactLoading from "react-loading";
import { faClose } from "@fortawesome/free-solid-svg-icons";
import { forgotPassword } from "../../../api/auth";
import { toast } from "react-toastify";
import { useAppDispatch } from "../../../hooks/reduxHooks";

const ForgotPassword = () => {
  const [error, setError] = useState<string | null>();
  const [email, setEmail] = useState<string>();
  const [loading, setLoading] = useState<boolean>(false);
  const [submitted, setSubmitted] = useState<boolean>(false);
  const [success, setSuccess] = useState<any>(false);

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  const dispatch = useAppDispatch();
  useEffect(() => {
    applyOverlay();
    return () => removeOverlay();
  }, []);

  const applyOverlay = () => {
    document.getElementById("App")!.style.opacity = "0.5";
    document.getElementById("App")!.style.overflowY = "hidden";
  };
  const removeOverlay = () => {
    document.getElementById("App")!.style.opacity = "1";
    document.getElementById("App")!.style.overflowY = "visible";
  };

  const onCloseClicked = () => {
    dispatch(setForgotPasswordVisible(false));
  };

  const onSendClicked = () => {
    if (email) {
      document.getElementById("email-input")!.style.border =
        "1px solid #d7d7d7";
      forgotPassword(email)
        .then((resp: any) => {
          setSuccess(resp);
        })
        .finally(() => {
          setEmail("");
          setSubmitted(true);
        });
    } else {
      document.getElementById("email-input")!.style.border = "1px solid red";
      setError("Please enter an email");
    }
  };

  const onBackToLoginClicked = () => {
    dispatch(setForgotPasswordVisible(false));
    dispatch(setLoginVisible(true));
  };

  const modalStyle = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-40%",
      transform: "translate(-50%, -50%)",
    },
  };

  return (
    <Modal isOpen={true} style={modalStyle}>
      <div className="login-header">
        <p className="login-heading">Reset your password</p>
        <FontAwesomeIcon
          className="close-icon"
          icon={faClose}
          size="3x"
          color="#18283c"
          onClick={() => onCloseClicked()}
        />
      </div>
      <div className="login-section-container">
        {!submitted ? (
          <div
            className="login-section"
            style={{ width: window.innerWidth > 480 ? "42%" : "auto" }}
          >
            <p
              className="login-title"
              style={{
                width:
                  window.innerWidth > 480
                    ? window.innerWidth > 844
                      ? "85%"
                      : "45vw"
                    : "75%",
                marginLeft:
                  window.innerWidth > 480
                    ? window.innerWidth > 844
                      ? "-10%"
                      : "20%"
                    : "0%",
                fontSize: window.innerWidth <= 480 ? 12 : "inherit",
              }}
            >
              Please enter your email address to receive instructions on how to
              reset your password
            </p>
            <CustomInput
              label="Email Address"
              id="email-input"
              type="text"
              placeholder="Email Address"
              value={email}
              setValue={setEmail}
              containerStyle={{
                width: window.innerWidth < 1024 ? "40vw" : "95%",
              }}
              onKeyPress={(event) => {
                if (event.key === "Enter" && !loading) {
                  onSendClicked();
                }
              }}
            />
            {error && (
              <div className="login-error-container">
                <p className="error-text">{error}</p>
              </div>
            )}
            <div
              style={{
                marginLeft: window.innerWidth > 480 ? "-62%" : "-45%",
              }}
              className="login-button-modal"
              onClick={() => onSendClicked()}
            >
              {!loading ? (
                <p>Send</p>
              ) : (
                <ReactLoading type="bubbles" color="white" />
              )}
            </div>
            <p
              style={{
                marginLeft: window.innerWidth > 480 ? "-70%" : "-55%",
              }}
              className="back-to-login"
              onClick={() => onBackToLoginClicked()}
            >
              Back to login
            </p>
          </div>
        ) : success.status ? (
          <div
            className="login-section"
            style={{ width: window.innerWidth > 480 ? "42%" : "auto" }}
          >
            <div className="reset-subtitle">
              <p>We’ve sent you a link to reset your password.</p>
              <p>Please note this link will expire in 24 hours</p>
              <p
                className="back-to-login"
                style={{ margin: 0, marginTop: "10%" }}
                onClick={() => {
                  setSubmitted(false);
                  setSuccess(null);
                }}
              >
                Back to Forgot Password
              </p>
            </div>
          </div>
        ) : (
          <div
            className="login-section"
            style={{ width: window.innerWidth > 480 ? "42%" : "auto" }}
          >
            <div className="reset-subtitle">
              <p>We’ve sent you a link to reset your password.</p>
              <p>Please note this link will expire in 24 hours</p>
              <p
                className="back-to-login"
                style={{ margin: 0, marginTop: "10%" }}
                onClick={() => {
                  setSubmitted(false);
                  setSuccess(null);
                }}
              >
                Back to Forgot Password
              </p>
            </div>
          </div>
        )}

        <div className="login-image">
          <Lottie
            options={defaultOptions}
            height={500}
            width={500}
            isStopped={false}
            isPaused={false}
          />
        </div>
      </div>
    </Modal>
  );
};

export default ForgotPassword;
